<template>
  <div class="page-container">
    <div class="grid-container">
      <div class="videoPlayer">
        <div id="player">
          <YoutubeVideoPlayer :video-id="videoId" />
        </div>
        <div id="metadata">
          <div id="videoTitle">{{ videoTitle }}</div>
          <div id="top-row">
            <YoutubeVideoTopRow />
          </div>
          <div id="bottom-row">
            <YoutubeVideoBottomRow />
          </div>
        </div>
      </div>
      <div class="video-list">
        <VideoListVertical />
      </div>
      <div class="comments">
        <YoutubeComments />
      </div>
    </div>
  </div>
</template>

<script>
import YoutubeVideoPlayer from "./YoutubeVideoPlayer.vue";
import YoutubeVideoTopRow from "./YoutubeVideoTopRow.vue";
import YoutubeVideoBottomRow from "./YoutubeVideoBottomRow.vue";
import YoutubeComments from "./YoutubeComments.vue";
import VideoListVertical from "./VideoListVertical.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    YoutubeVideoPlayer,
    YoutubeVideoTopRow,
    YoutubeVideoBottomRow,
    YoutubeComments,
    VideoListVertical,
  },
  computed: {
    ...mapGetters("youtube", {
      post: "getSelectedPost",
    }),

    videoTitle() {
      return this.post.body.body.bottomRow.link.text.title;
    },
    videoId() {
      return this.post.body.body.bottomRow.link.text.subtitle;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/youtube-styles.scss";

.page-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.grid-container {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "video sidebar"
    "comments sidebar";
  gap: 24px;
  width: 100%;
  max-width: 1600px;
  padding: 24px;
  margin: 0 auto;
  box-sizing: border-box;
}

.videoPlayer {
  grid-area: video;
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
}

#player {
  width: 100%;
  aspect-ratio: 16 / 9;
  max-width: 100%;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

#metadata {
  margin-top: 16px;
}

#videoTitle {
  font-size: 20px;
  font-weight: bold;
  color: $youtube-text-primary-color;
  line-height: 1.4;
  margin-bottom: 12px;
}

.video-list {
  grid-area: sidebar;
  width: 100%;
  min-width: 0;
}

.comments {
  grid-area: comments;
  width: 100%;
  min-width: 0;
}

// Wider screens: more space for video
@media screen and (min-width: 1800px) {
  .grid-container {
    max-width: 1800px;
    grid-template-columns: 4fr 1fr;
    gap: 32px;
  }
}

// Large desktop
@media screen and (max-width: 1599px) {
  .grid-container {
    max-width: 1400px;
    grid-template-columns: 3fr 1fr;
    gap: 24px;
  }
}

// Medium desktop
@media screen and (max-width: 1399px) {
  .grid-container {
    max-width: 1200px;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
  }
}

// Small desktop
@media screen and (max-width: 1200px) {
  .grid-container {
    max-width: 1000px;
    grid-template-columns: 2fr 1fr;
    gap: 16px;
    padding: 20px;
  }
}

// Tablet / Small screen
@media screen and (max-width: 1024px) {
  .grid-container {
    max-width: 100%;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "video"
      "sidebar"
      "comments";
    gap: 16px;
    padding: 16px;
  }

  #player {
    border-radius: 0;
  }
}

// Mobile
@media screen and (max-width: 768px) {
  .grid-container {
    gap: 12px;
    padding: 12px;
  }

  #metadata {
    margin-top: 12px;
  }

  #videoTitle {
    font-size: 18px;
    margin-bottom: 8px;
  }
}

// Small mobile
@media screen and (max-width: 480px) {
  .grid-container {
    gap: 8px;
    padding: 8px;
  }
}
</style>
